import { OperatorType } from 'bones/utils/queryBuilder/constants';
import { DraftTopExpression } from 'bones/utils/queryBuilder/types';

export const validateInstanceProperty = ({
  topExpression,
  subExpressionIdx,
  expressionIdx,
  filterIdx,
}: {
  topExpression: DraftTopExpression;
  subExpressionIdx: number;
  expressionIdx: number;
  filterIdx: number;
}): boolean => {
  const subExpression = topExpression.expressions[subExpressionIdx];
  const expression = subExpression.expressions[expressionIdx];
  const filter = expression.filters[filterIdx];
  const filterSubject = filter.subject;
  if (!filterSubject) {
    return true;
  }

  return !subExpression.expressions
    .slice(0, expressionIdx + 1)
    .some((expression, expIdx) =>
      (expressionIdx === expIdx
        ? expression.filters.slice(0, filterIdx)
        : expression.filters
      ).some(
        ({ subject, operator }) =>
          subject &&
          operator &&
          operator.operatorType === OperatorType.INSTANCE &&
          subject.id === filterSubject.id &&
          subject.iri === filterSubject.iri
      )
    );
};
